import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SetupModelsService } from '../../setup-models/setup-models.service';
import { DealershipsCustomers, PartConfiqQuoteBillingDetails, UserDealerGroup, UserDealerGroupDealerships } from '../../setup-models/setup-models.model';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-billing-detail',
  templateUrl: './billing-detail.component.html',
  styleUrls: ['./billing-detail.component.scss']
})
export class BillingDetailComponent implements OnInit {
  validEmailString: boolean = false;
  emailAddress: string = "";
  emailControl: FormControl;
  userDealerGroupDealerships: UserDealerGroupDealerships[];
  dealerGroupId: number=0;
  dealershipId: number=0;
  selectedCustomer: number=0;
  dealershipsCustomers: DealershipsCustomers[];
  chainId:number;
  FirstName:string="";
  LastName:string="";
  ContactNo:number=0;
  checked:number;
  constructor( @Inject(MAT_DIALOG_DATA) private _data: any,public dialogRef: MatDialogRef<BillingDetailComponent>
  , public _modelService: SetupModelsService,private _notify: NotificationsService) { }

  ngOnInit(): void {

    this.chainId = this._data.ChainID;
    this.getConfigQuote();
    this.GetUserDealerGroup();
    this.emailControl = new FormControl(this.emailAddress, [
      Validators.required,
      Validators.email,
    ]);
   
      
    
  }

  onNoClick() {
    this.dialogRef.close(false);
  }
  checkEmailAddress() {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.validEmailString = re.test(String(this.emailAddress).toLowerCase());
  }
  userDealerGroup: UserDealerGroup[];

  GetUserDealerGroup() {
    this._modelService.GetUserDealerGroup().subscribe(result => {
      this.userDealerGroup = result;
     
      
        this.GetUserDealerGroupDealerships();
    
    })
  }

  GetUserDealerGroupDealerships() {
    this._modelService.GetUserDealerGroupDealerships(this.dealerGroupId).subscribe(result => {
      this.userDealerGroupDealerships = result;
        this.GetDealerGroupDealershipsCustomers();
     
    })
  }

  GetDealerGroupDealershipsCustomers() {
    this._modelService.GetDealerGroupDealershipsCustomers(this.dealershipId).subscribe(result => {
      this.dealershipsCustomers = result;
      
    })

  }

  OndealerGroupSelect() {
    this.GetUserDealerGroupDealerships();
  }


  OndealershipSelect() {
    this.GetDealerGroupDealershipsCustomers();
  }
  BillingAddress: string;
  DeliveryAddress: string;
  changeCheckbox(event: any) {
    if (event.checked) {
      this.BillingAddress = this.DeliveryAddress
    }else{
      this.BillingAddress="";
    }
  }
  SavePartConfiqQuote() {
    let Isconfirm:boolean;
    Isconfirm=false;
    this._modelService.SavePartConfiqQuote(this.dealerGroupId,this.dealershipId,this.selectedCustomer,
      this.FirstName, this.LastName, this.emailAddress, this.chainId,this.ContactNo,this.BillingAddress,this.DeliveryAddress
    ,Isconfirm).subscribe(result => {
      if(result!=null){
        this.getConfigQuote();
        this._notify.success("Billing Details Saved Successfully!");
        this.dialogRef.close();
      }
    })
  }
  PartConfiqQuoteBillingDetails: PartConfiqQuoteBillingDetails;
  getConfigQuote() {
    this.PartConfiqQuoteBillingDetails=null;
    this._modelService.GetPartConfiqQuote(this.chainId).subscribe(result => {
      if (result != null) {
        this.PartConfiqQuoteBillingDetails = result;
        if(this.PartConfiqQuoteBillingDetails!=null){
          this.dealerGroupId=this.PartConfiqQuoteBillingDetails.DealerGroupId;
          this.dealershipId=this.PartConfiqQuoteBillingDetails.DealershipId;
          this.selectedCustomer=this.PartConfiqQuoteBillingDetails.CustomerId;
          this.FirstName=this.PartConfiqQuoteBillingDetails.FirstName
          this.LastName=this.PartConfiqQuoteBillingDetails.LastName;
          this.emailAddress=this.PartConfiqQuoteBillingDetails.EmailId;
          this.ContactNo=this.PartConfiqQuoteBillingDetails.ContactNumber;
          this.BillingAddress=this.PartConfiqQuoteBillingDetails.BillingAddress;
          this.DeliveryAddress=this.PartConfiqQuoteBillingDetails.DeliveryAddress;
          if(this.BillingAddress== this.DeliveryAddress){
            this.checked=1;
          }else{
            this.checked=0;
          }
        }
      }else{
        
      }
    })
  }
}
